<template>
  <span class="status-badge" :class="statusClass">
    <i v-if="showIcon" :class="statusIcon" class="status-icon"></i>
    {{ statusText }}
  </span>
</template>

<script>
export default {
  name: 'Status',
  props: {
    status: {
      type: [Object, String],
      required: true
    },
    showIcon: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    statusText() {
      const text = this.statusRealText
      if(text === 'ÚJ'){
        return 'Feldolgozás alatt'
      }else{
        return text
      }
    },
    statusRealText() {
      if (typeof this.status === 'object') {
        return this.status.name || this.status
      }
      return this.status
    },
    statusClass() {
      const statusLower = this.statusText.toLowerCase()
      
      // Új projekt
      if (statusLower === 'feldolgozás alatt') {
        return 'status-new'
      }
      
      // Teljesült projekt
      if (statusLower === 'teljesült') {
        return 'status-completed'
      }
      
      // Összes többi státusz
      return 'status-in-progress'
    },
    statusIcon() {
      const statusLower = this.statusText.toLowerCase()
      
      if (statusLower === 'új') {
        return 'fas fa-star'
      }
      
      if (statusLower === 'teljesült') {
        return 'fas fa-check-circle'
      }
      
      return 'fas fa-clock'
    }
  }
}
</script>

<style scoped>
.status-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 500;
  text-transform: uppercase;
  transition: all 0.2s ease;
}

.status-icon {
  font-size: 10px;
}

/* Új projekt - Kék */
.status-new {
  background: #e3f2fd;
  color: #1565c0;
  border: 1px solid #90caf9;
}

/* Folyamatban lévő projekt - Narancs/Sárga */
.status-in-progress {
  background: #fff3e0;
  color: #e65100;
  border: 1px solid #ffb74d;
}

/* Teljesült projekt - Zöld */
.status-completed {
  background: #e8f5e9;
  color: #2e7d32;
  border: 1px solid #81c784;
}

/* Alapértelmezett - Szürke */
.status-default {
  background: #f5f5f5;
  color: #616161;
  border: 1px solid #e0e0e0;
}

/* Hover effekt */
.status-badge:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
</style>